import NextLink from 'next/link'
import { Link, Box, Text, Flex, Stack, HStack, Divider, Spacer, VStack, Badge, Wrap, WrapItem, Heading, LinkBox, LinkOverlay, useColorModeValue } from '@chakra-ui/react'

export default function GeneCard(props) {
    const bg = useColorModeValue("white", "")
    const color = useColorModeValue("black", "neutral.200")
    const borderColor = useColorModeValue("gray.100", "neutral.900")
    return (
    
        <LinkBox as="article" w="100%" p={8} bg={bg} color={color} borderRadius={15} border="1px" borderColor={borderColor}>

        <Box flexShrink={0}>
        <HStack>
        <Box>
        <Box
            mt="1"
            fontWeight="semibold"
            as="h4"
            lineHeight="tight"
            isTruncated
            align="left"
        >
             <NextLink href={`/genes/${props.gene.slug}`} passHref>
                 <LinkOverlay>
            <Heading as="h2" size="md">{props.gene.symbol}</Heading>
            </LinkOverlay>
            </NextLink>
        </Box>
        <Box>
            <Text fontSize="sm" fontWeight="normal">{props.gene.name}</Text>
        </Box>
        </Box>
        <Spacer />
        <Box align="right">
        <Text color="gray.400" fontSize={11} fontWeight="bold">
        {props.gene.locus_type.toUpperCase()}
        </Text>
        </Box>
        </HStack>
        
        {/* {props.gene.phenotypes.length > 0 ? 
        <Box>
        <Divider orientation="horizontal" mt={5} colorScheme="red" borderColor={borderColor}/>

        <Box mt={2}>
            <Heading as="h6" size="xs" color="#849294" fontWeight="bold" fontSize="12px">CONDITIONS</Heading>
        </Box>
        
        {props.gene.phenotypes.length > 3 ?
        <Wrap mt={2}>
        {props.gene.phenotypes.slice(0,3).map(condition => 
        <WrapItem key={condition.name}>
              <Badge ml="0" colorScheme="cyan" borderRadius="lg" pl={3} pr={3} pt={0.2} pb={0.2} textTransform="capitalize">
              {condition.name}
            </Badge>
            </WrapItem>
        )}
        
        <Heading size={"xs"} fontSize={"12"} ml="0" colorScheme="grsay" borderRadius="lg" pl={3} pr={3} pt={0.5} textTransform="capitalize">+{props.gene.phenotypes.length - 3} MORE</Heading>
        </Wrap>
        : 
        <Wrap mt={2}>
        {props.gene.phenotypes.map(condition => 
        <WrapItem key={condition.name}>
              <Badge ml="0" colorScheme="cyan" borderRadius="lg" pl={3} pr={3} pt={0.2} pb={0.2} textTransform="capitalize">
              {condition.name}
            </Badge>
            </WrapItem>
        )}
        </Wrap>
        }
        
        

        </Box>
        : null} */}
        </Box>

        </LinkBox>
        
    )
}